import { AnonymousAuthenticationProvider } from "@microsoft/kiota-abstractions";
import { DefaultRequestAdapter } from "@microsoft/kiota-bundle";
import { KiotaClientFactory } from "@microsoft/kiota-http-fetchlibrary";
import { createMoneyCheckerApiClient, type MoneyCheckerApiClient } from "ApiClient/moneyCheckerApiClient";
import { Configuration } from "./Configuration/Configuration";

/**
 * Creates the Kiota-generated API client, pointed at the API base URL resolved from `/config`
 * (see Configuration.refresh(), which must have completed before this is called).
 *
 * Authentication is cookie-based: the session cookie set by the login endpoint is sent
 * automatically by the browser on every subsequent request, so no token provider is needed.
 * `credentials: "include"` ensures the cookie is attached even for cross-origin requests.
 */
export function createApiClient(): MoneyCheckerApiClient {
    const { apiUrl } = Configuration.get();
    if (!apiUrl) {
        throw new Error("Configuration.refresh() must complete before creating the API client.");
    }

    const fetchWithCredentials: typeof fetch = (input, init) =>
        fetch(input, { ...init, credentials: "include" });

    const httpClient = KiotaClientFactory.create(fetchWithCredentials);

    const requestAdapter = new DefaultRequestAdapter(new AnonymousAuthenticationProvider(), undefined, undefined, httpClient);
    requestAdapter.baseUrl = apiUrl;

    return createMoneyCheckerApiClient(requestAdapter);
}